(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vane-welcome-popup"]) return;
  try {
    
  if (!customElements.get('vane-welcome-popup')) {
    customElements.define('vane-welcome-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.storageKey = 'vane-welcome-dismissed-v1';
        this.seenKey = 'vane-welcome-seen-v1';
        this.pendingKey = 'vane-welcome-pending-v1';
        this.designMode = this.dataset.designMode === 'true';
        this.previousFocus = null;
        this.querySelector('form')?.addEventListener('submit', () => {
          this.submitting = true;
          this.rememberDismissal();
          try { sessionStorage.setItem(this.pendingKey, '1'); } catch {}
          this.dialog.close();
        });
        this.querySelectorAll('[data-vane-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('close', () => {
          if (this.privacyPausedClose) {
            this.privacyPausedClose = false;
            return;
          }
          this.rememberDismissal();
          if (!this.submitting) {
            try { sessionStorage.removeItem(this.pendingKey); } catch {}
          }
          if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll: true});
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.querySelector('[data-vane-copy]')?.addEventListener('click', async event => {
          const button = event.currentTarget;
          try {
            await navigator.clipboard.writeText(this.querySelector('[data-vane-code]').textContent.trim());
            button.textContent = button.dataset.copiedLabel;
          } catch {
            const range = document.createRange();
            range.selectNodeContents(this.querySelector('[data-vane-code]'));
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          }
        });
        this.result = this.querySelector('[data-vane-result]')?.dataset.vaneResult;
        this.handleStorage = event => {
          if (this.designMode || event.key !== this.storageKey || event.newValue !== '1') return;
          window.clearTimeout(this.timer);
          if (this.result === 'idle' && this.dialog.open) this.dialog.close();
        };
        window.addEventListener('storage', this.handleStorage);
        this.handlePageShow = event => {
          if (!event.persisted || this.designMode || (!this.isDismissed() && !this.wasSeen())) return;
          window.clearTimeout(this.timer);
          if (this.dialog.open) this.dialog.close();
        };
        window.addEventListener('pageshow', this.handlePageShow);
        this.handlePrivacyConsent = () => {
          if (this.result !== 'idle' || !this.isConnected) return;
          window.clearTimeout(this.timer);
          this.timer = window.setTimeout(() => this.open(), Number(this.dataset.delay) || 0);
        };
        document.addEventListener('visitorConsentCollected', this.handlePrivacyConsent);
        this.privacyObserver = new MutationObserver(() => {
          if (this.designMode || !this.dialog.open || !this.hasVisiblePrivacyDialog()) return;
          this.privacyPausedClose = true;
          this.dialog.close();
          if (this.result === 'idle') {
            try { sessionStorage.removeItem(this.seenKey); } catch {}
          }
          this.scheduleOpen(this.result === 'success' || this.result === 'error');
        });
        this.privacyObserver.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'class', 'style']});
        const dismissed = this.isDismissed();
        if (dismissed) this.rememberDismissal();
        if (this.result === 'success' || this.result === 'error') {
          let pending = false;
          try { pending = sessionStorage.getItem(this.pendingKey) === '1'; } catch {}
          if (pending || !dismissed || this.designMode) this.open(true);
          return;
        }
        if (!this.designMode && this.dataset.subscriber === 'true') {
          this.rememberDismissal();
          return;
        }
        if (!this.designMode && (dismissed || this.wasSeen())) return;
        this.timer = window.setTimeout(() => this.open(), Number(this.dataset.delay) || 0);
      }
      isDismissed() {
        try { if (localStorage.getItem(this.storageKey) === '1') return true; } catch {}
        try { if (sessionStorage.getItem(this.storageKey) === '1') return true; } catch {}
        return false;
      }
      wasSeen() {
        try { return sessionStorage.getItem(this.seenKey) === '1'; } catch { return false; }
      }
      rememberDismissal() {
        if (this.designMode) return;
        try { localStorage.setItem(this.storageKey, '1'); } catch {}
        try { sessionStorage.setItem(this.storageKey, '1'); } catch {}
      }
      scheduleOpen(showResult = false) {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.open(showResult), 500);
      }
      hasVisiblePrivacyDialog() {
        return Array.from(document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs__dialog')).some(element => element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
      }
      open(showResult = false) {
        if (!this.isConnected || this.dialog.open) return;
        if (!showResult && !this.designMode && (this.isDismissed() || this.wasSeen())) return;
        if (!this.designMode && !showResult) {
          this.privacyWaitUntil ??= Date.now() + 8000;
          const privacy = window.Shopify?.customerPrivacy;
          let awaitingPrivacy = true;
          if (typeof privacy?.shouldShowBanner !== 'function' || typeof privacy?.currentVisitorConsent !== 'function') {
            if (!this.privacyLoadRequested && typeof window.Shopify?.loadFeatures === 'function') {
              this.privacyLoadRequested = true;
              try {
                window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => {
                  if (this.isConnected && !this.dialog.open) this.scheduleOpen();
                });
              } catch {}
            }
          } else {
            try {
              const consent = privacy.currentVisitorConsent() || {};
              const consentAnswered = ['analytics', 'marketing', 'preferences'].every(purpose => consent[purpose] === 'yes' || consent[purpose] === 'no');
              awaitingPrivacy = privacy.shouldShowBanner() && !consentAnswered;
            } catch {}
          }
          if (awaitingPrivacy && Date.now() < this.privacyWaitUntil) {
            this.scheduleOpen();
            return;
          }
        }
        const blockingModal = Array.from(document.querySelectorAll('dialog[open]:not(.vane-welcome), [role="dialog"]:not(.vane-welcome), [role="alertdialog"], #shopify-pc__banner')).some(element => element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
        if (blockingModal) {
          this.scheduleOpen(showResult);
          return;
        }
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        if (!this.designMode) {
          try { sessionStorage.setItem(this.seenKey, '1'); } catch {}
        }
        if (showResult) {
          this.rememberDismissal();
          try { sessionStorage.removeItem(this.pendingKey); } catch {}
        }
      }
      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.privacyObserver?.disconnect();
        window.removeEventListener('storage', this.handleStorage);
        window.removeEventListener('pageshow', this.handlePageShow);
        document.removeEventListener('visitorConsentCollected', this.handlePrivacyConsent);
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
